"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('thumbs-down', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M20.3796043,29.4 L20.3796043,36.6 C20.3796043,39.5823376 22.7972666,42 25.7796043,42 L32.9796043,25.8 L32.9796043,5.99976661 L12.0636043,5.99976661 C10.2684881,5.97970615 8.7327742,7.285063 8.46360428,9.06 L5.97960428,25.26 C5.82110344,26.3042604 6.12918937,27.3654442 6.82225896,28.1624742 C7.51532856,28.9595042 8.52345122,29.4119604 9.57960428,29.4 L20.3796043,29.4 Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M32.9796043,6 L37.7856043,6 C39.8942856,5.96270749 41.6969066,7.51002165 41.9796043,9.6 L41.9796043,22.2 C41.6969066,24.2899783 39.8942856,26.0372925 37.7856043,26 L32.9796043,26 L32.9796043,6 Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }))));
});

exports.default = _default;